import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import GiftcardDetailsSkeletonWeb from "./layouts/GiftcardDetailsSkeleton.web";
import GiftcardDetailsSkeletonMob from "./layouts/GiftcardDetailsSkeleton.mob";

const GiftcardDetailsSkeletonComponent = withConditionalComponent(GiftcardDetailsSkeletonWeb, GiftcardDetailsSkeletonMob);

export default function GiftcardDetailsSkeleton() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <GiftcardDetailsSkeletonComponent trigger={isLargeScreen} />;
}
